module.exports = __webpack_public_path__ + "assets/img/anders-denken.08ab92bd.png";